/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

const retornaCss = (props) => {
  let retorno = 'dtp-datagrid-header';
  if (props && props.cssLinha) {
    retorno = props.cssLinha;
  }
  return retorno;
};

const DataGridCustom = props => (
  <section className="dtp-datagrid">
    {!props.retirarLinhaSeparadora ?
      <h3 className={props.retirarLinhaSeparadora ? 'header-sem-linha' : retornaCss(props)}>{props.title}</h3> : ''}
    <div className="dtp-datagrid-data">
      <div className="dtp-datagrid-items-box" >
        {props.children}
      </div>
    </div>
  </section>
);

DataGridCustom.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.element,
  retirarLinhaSeparadora: PropTypes.bool,
  cssLinha: PropTypes.string,
}.isRequired;

export default DataGridCustom;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/DataGridCustom.jsx